import * as yup from 'yup';
import { ERR_ZIPCODE_FIND } from '../../../constants/response-error-messages';
import { PO_BOX_ADDRESS, COMPANY_NAME_INVALID, COMPANY_NAME_TOO_LONG, FIRST_NAME_REQUIRED, LAST_NAME_REQUIRED, SHIPPING_ADDRESS_INVALID, ZIP_CODE_REQUIRED, ZIP_CODE_INVALID, PHONE_REQUIRED, FIRST_NAME_INVALID, LAST_NAME_INVALID, FIRST_NAME_TOO_LONG, LAST_NAME_TOO_LONG, ADDRESS_NICK_NAME_INVALID, ADDRESS_NICKNAME_TOO_LONG, } from '../../../constants/field-error-messages';
import { NAME_REGEX, PO_BOX_ADDRESS_REGEX, COMPANY_NAME_REGEX, NON_DIGITS_REGEX, ADDRESS_REGEX, ZIPCODE_REGEX, PHONE_REGEX, } from '../../../constants/regex';
const isAddressPoBox = (address = '') => !PO_BOX_ADDRESS_REGEX.test(address);
const isMoreThanSixtyChars = (address = '') => address.length <= 60;
export const validationSchema = yup.object().shape({
    firstName: yup
        .string()
        .trim()
        .max(40, FIRST_NAME_TOO_LONG.message)
        .required(FIRST_NAME_REQUIRED.message)
        .matches(NAME_REGEX, FIRST_NAME_INVALID),
    nickName: yup
        .string()
        .trim()
        .max(50, ADDRESS_NICKNAME_TOO_LONG.message)
        .matches(NAME_REGEX, {
        message: ADDRESS_NICK_NAME_INVALID.message,
        excludeEmptyString: true,
    }),
    lastName: yup
        .string()
        .trim()
        .max(60, LAST_NAME_TOO_LONG.message)
        .required(LAST_NAME_REQUIRED.message)
        .matches(NAME_REGEX, LAST_NAME_INVALID),
    companyName: yup
        .string()
        .trim()
        .max(100, COMPANY_NAME_TOO_LONG.message)
        .matches(COMPANY_NAME_REGEX, {
        message: COMPANY_NAME_INVALID.message,
        excludeEmptyString: true,
    }),
    addressLine1: yup
        .string()
        .trim()
        .required(SHIPPING_ADDRESS_INVALID.message)
        .matches(ADDRESS_REGEX, { message: SHIPPING_ADDRESS_INVALID.message })
        .test('address can not be P.O Box', PO_BOX_ADDRESS.message, isAddressPoBox)
        .test('address can not be more than 60 characters', SHIPPING_ADDRESS_INVALID.message, isMoreThanSixtyChars),
    addressLine2: yup
        .string()
        .trim()
        .matches(ADDRESS_REGEX, {
        message: SHIPPING_ADDRESS_INVALID.message,
        excludeEmptyString: true,
    })
        .test('address can not be more than 60 characters', SHIPPING_ADDRESS_INVALID.message, isMoreThanSixtyChars),
    zipCode: yup
        .string()
        .when('isZipCodeNotFoundError', {
        is: true,
        then: yup
            .string()
            .matches(NON_DIGITS_REGEX, { message: ZIP_CODE_INVALID.message }),
    })
        .when('isZipCodeApiError', {
        is: true,
        then: yup
            .string()
            .matches(NON_DIGITS_REGEX, { message: ERR_ZIPCODE_FIND.message }),
    })
        .required(ZIP_CODE_REQUIRED.message)
        .matches(ZIPCODE_REGEX, { message: ZIP_CODE_INVALID.message }),
    isZipCodePending: yup.boolean(),
    isZipCodeApiError: yup.boolean(),
    primaryPhone: yup
        .string()
        .required(PHONE_REQUIRED.message)
        .matches(PHONE_REGEX, { message: PHONE_REQUIRED.message }),
    alternatePhone: yup.string().matches(PHONE_REGEX, {
        message: PHONE_REQUIRED.message,
        excludeEmptyString: true,
    }),
});
